import React from "react";
import { Button } from "react-bootstrap";

export default function ListClient({ clientTypeList, handleClientTypeRemove }: { clientTypeList: { name: string, uuid: string }[], handleClientTypeRemove: (arg0: string) => void }) {
    return (
        <ul className="form-items list-trigger-criteria">
            <ListRows clientTypeList={clientTypeList} handleClientTypeRemove={handleClientTypeRemove} />
        </ul>
    );
};

function ListRows({ clientTypeList, handleClientTypeRemove }: { clientTypeList: { name: string, uuid: string }[], handleClientTypeRemove: (arg0: string) => void }) {

    if (!clientTypeList || clientTypeList.length === 0) {
        return <></>;
    }
    const rows = clientTypeList.map(client => {

        return (
            <li key={client.uuid}>
                <div className="reference">{client.name}</div>
                <div className="actions">
                    <Button onClick={() => { handleClientTypeRemove(client.uuid) }} type="button" variant="secondary" className="btn-delete" title="Supprimer ce client cible">
                        <span className="icon"></span>
                        <span className="text">Supprimer</span>
                    </Button>
                </div>
            </li>
        );
    });

    return <>{rows}</>;
}
